import React from 'react';
import { Box, VStack, Text, Spinner, Button } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

// Full-height overlay shown before the conversation is ready.
// - variant "connecting": spinner + "waiting for connection" copy while the
//   chat authorizes and the websocket comes up (input is blocked meanwhile).
// - variant "error": clear message + retry button when authorization fails.
const ConnectionState = ({ variant, colors, onRetry }) => {
    const { t } = useTranslation('chat');

    return (
        <Box
            flex={1}
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            gap={4}
            px={6}
            textAlign="center"
        >
            {variant === 'connecting' ? (
                <VStack gap={4}>
                    <Spinner size="lg" color={colors.avatarBg} />
                    <Text color={colors.textSecondary} fontSize="sm" maxW="320px" lineHeight="1.5">
                        {t('connecting.message')}
                    </Text>
                </VStack>
            ) : (
                <VStack gap={3}>
                    <Text color={colors.textPrimary} fontWeight="bold">
                        {t('error.title')}
                    </Text>
                    <Text color={colors.textSecondary} fontSize="sm" maxW="360px" lineHeight="1.5">
                        {t('error.description')}
                    </Text>
                    {onRetry && (
                        <Button
                            mt={2}
                            bg={colors.avatarBg}
                            color="white"
                            borderRadius="10px"
                            px={6}
                            fontWeight="600"
                            onClick={onRetry}
                            _hover={{ opacity: 0.9 }}
                        >
                            {t('error.retry')}
                        </Button>
                    )}
                </VStack>
            )}
        </Box>
    );
};

export default ConnectionState;
